import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _defineProperty from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from "echarts";
import { getBannerList, getCourseNum, getPositionList, getTradeResourceNum, getPageNumList, getRandomList100, getResourceNum, getSpecialCount } from "@/api/home/index";
import { newsTypeList, newsListMenhu } from "@/api/news/newsMenhu";
import axios from "axios";
import { getToken } from "@/libs/auth";
export default {
  components: {
    zswiper: function zswiper() {
      return import("./components/zswiper");
    },
    zswiperItem: function zswiperItem() {
      return import("./components/zswiperItem");
    },
    MobileHeader: function MobileHeader() {
      return import("./mobile/MobileHeader");
    },
    MobileBanner: function MobileBanner() {
      return import("./mobile/MobileBanner");
    },
    MobileInternationalEntry: function MobileInternationalEntry() {
      return import("./mobile/MobileInternationalEntry");
    },
    MobileUserTypes: function MobileUserTypes() {
      return import("./mobile/MobileUserTypes");
    },
    MobileQuickService: function MobileQuickService() {
      return import("./mobile/MobileQuickService");
    },
    MobileOccupation: function MobileOccupation() {
      return import("./mobile/MobileOccupation");
    },
    MobileIndustry: function MobileIndustry() {
      return import("./mobile/MobileIndustry");
    },
    MobileMajorCat: function MobileMajorCat() {
      return import("./mobile/MobileMajorCat");
    },
    MobileSpecial: function MobileSpecial() {
      return import("./mobile/MobileSpecial");
    },
    MobileResource: function MobileResource() {
      return import("./mobile/MobileResource");
    },
    MobileFooter: function MobileFooter() {
      return import("./mobile/MobileFooter");
    }
  },
  filters: {
    day: function day(val) {
      if (val) return val.slice(8, 10);
    },
    year: function year(val) {
      if (val) return val.slice(0, 7);
    }
  },
  data: function data() {
    return {
      headshowMenu: false,
      bannerData: [],
      typesList: [{
        name: "教师",
        link: "/teacherPower",
        type: "ls",
        txt: "更方便的教学"
      }, {
        name: "学生",
        link: "/courseSearch",
        type: "xs",
        txt: "应有尽有，超多资源"
      }, {
        name: "社会学习者",
        link: "",
        type: "shxz",
        txt: "更好的提升自己"
      }],
      isActive: 0,
      //竖直轮播图索引

      //新模块 1 2
      homeNavList: [{
        type: '1',
        url: '/professionalTeaching',
        name: '专业与课程服务中心',
        resourceTypeTotal: [{
          name: '专业资源库',
          total: 0
        }, {
          name: '在线精品课',
          total: 0
        }, {
          name: '视频公开课',
          total: 0
        }]
      }, {
        type: '2',
        url: '/virtual',
        name: '虚拟仿真实训中心',
        resourceTypeTotal: [{
          name: '课程数量',
          total: 0
        }]
      }, {
        type: '3',
        url: '/teacherPower',
        name: '教师能力提升中心',
        resourceTypeTotal: [{
          name: '课程数量',
          total: 0
        }]
      }, {
        type: '4',
        url: '/books',
        name: '教材资源中心',
        resourceTypeTotal: [{
          name: '课程数量',
          total: 0
        }]
      }, {
        type: '5',
        url: '/communityEducation',
        name: '首都特色教育',
        resourceTypeTotal: [{
          name: '课程数量',
          total: 0
        }]
      }],
      ntwoData: [{
        id: 1,
        eduLevel: 1,
        resourceData: '德育'
      }, {
        id: 2,
        eduLevel: 1,
        resourceData: '体育'
      }, {
        id: 3,
        eduLevel: 1,
        resourceData: '美育'
      }, {
        id: 4,
        eduLevel: 1,
        resourceData: '劳动教育'
      }],
      //获取行业数量
      industryData: [],
      // 获取专业大类数量
      majorData: [],
      fourIcon: "",
      // 获取资源知识
      knowledgeData: [],
      //想要的知识
      knowSearch: "",
      // 获取资源类型数量
      resType: [{
        id: 1,
        name: "课程数量",
        count: "0",
        text: "课程即轨道，努力向前跑"
      }, {
        id: 2,
        name: "视频素材",
        count: "0",
        text: "智力挑战，思维碰撞，个性张扬"
      }, {
        id: 3,
        name: "虚拟仿真实训",
        count: "0",
        text: "经验获得自信，合作换来共赢"
      }, {
        id: 4,
        name: "教材资源",
        count: "0",
        text: "根基壮起来，枝叶旺起来，花儿红起来"
      },
      // {id:5,name:"微课",count:"4000",text:"走进新课程，全面提高学生文化素养"},
      {
        id: 6,
        name: "在线直播",
        count: "0",
        text: "课堂是教育的心脏，走进新课堂"
      }],
      //从事职业
      twoData: [],
      resourceTotal: 0,
      resourceShow: false,
      timer: null,
      newsTabList: [{
        type: '新闻中心',
        id: ''
      }, {
        type: '通知公告',
        id: ''
      }],
      newsCurIndex: 1,
      newsList: [],
      newsTotal: 0,
      newsLoading: false,
      newsQuery: {
        upperShelf: 1,
        newsTypeId: '',
        newsTitle: '',
        pageNum: 1,
        pageSize: 4
      }
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.getters.userInfo || {};
    },
    mobileCssVars: function mobileCssVars() {
      return {
        "--ml-padding-bottom": "20px",
        "--ml-bg": "#f5f7fa"
      };
    }
  },
  mounted: function mounted() {
    this.initCourse();
    this.handleNationEduError();
  },
  methods: {
    isMobile: function isMobile() {
      return window.innerWidth < 800;
    },
    showToast: function showToast(message, type) {
      if (!this.isMobile()) {
        if (type === 'warning') {
          this.$message.warning(message);
        } else if (type === 'error') {
          this.$message.error(message);
        } else {
          this.$message(message);
        }
        return;
      }
      var iconMap = {
        success: "\u2714",
        warning: "\u26A0",
        error: "\u2716",
        info: "\u2139"
      };
      var colorMap = {
        success: '#52c41a',
        warning: '#faad14',
        error: '#ff4d4f',
        info: '#1668f4'
      };
      var icon = iconMap[type] || iconMap.info;
      var color = colorMap[type] || colorMap.info;
      var existing = document.getElementById('mobile-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.id = 'mobile-toast';
      toast.innerHTML = '<span class="mobile-toast__icon">' + icon + '</span><span class="mobile-toast__text">' + message + '</span>';
      toast.className = 'mobile-toast mobile-toast--' + type;
      Object.assign(toast.style, {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '99999',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '20px 28px',
        borderRadius: '12px',
        background: '#fff',
        boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
        maxWidth: '85%',
        boxSizing: 'border-box',
        opacity: '0',
        transition: 'opacity 0.25s ease'
      });
      var iconEl = toast.querySelector('.mobile-toast__icon');
      Object.assign(iconEl.style, {
        fontSize: '24px',
        color: color,
        flexShrink: '0',
        lineHeight: '1'
      });
      var textEl = toast.querySelector('.mobile-toast__text');
      Object.assign(textEl.style, {
        fontSize: '18px',
        color: '#333',
        lineHeight: '1.5',
        fontWeight: '500'
      });
      document.body.appendChild(toast);
      requestAnimationFrame(function () {
        toast.style.opacity = '1';
      });
      setTimeout(function () {
        toast.style.opacity = '0';
        setTimeout(function () {
          if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 300);
      }, 3000);
    },
    // 进入国际专区 — 公开页面，无需登录
    goInternational: function goInternational() {
      this.$router.push('/international/home');
    },
    goNationEdu: function () {
      var _goNationEdu = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var baseApi, response, result, errorCode, messages, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (getToken()) {
                _context.next = 1;
                break;
              }
              this.showToast("请先登录门户账号", "warning");
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              // 通过 Ajax 请求携带 Authorization，再跳转到国家平台页面。
              baseApi = process.env.VUE_APP_BASE_API || "/dev-api";
              _context.next = 2;
              return axios.get("".concat(baseApi, "/system/auth/nationEdu/prepare"), {
                headers: {
                  Authorization: "Bearer ".concat(getToken())
                }
              });
            case 2:
              response = _context.sent;
              result = response && response.data;
              if (!(!result || result.code !== 200 || !result.data)) {
                _context.next = 3;
                break;
              }
              errorCode = result && result.data;
              messages = {
                "local-user": "当前账号没有可用的教育ID",
                "bind-status": "国家平台绑定状态异常",
                remote: "国家平台认证服务暂时不可用"
              };
              this.showToast(messages[errorCode] || "国家平台认证失败", "error");
              return _context.abrupt("return");
            case 3:
              window.location.href = result.data;
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              this.showToast("国家平台认证服务暂时不可用", "error");
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 4]]);
      }));
      function goNationEdu() {
        return _goNationEdu.apply(this, arguments);
      }
      return goNationEdu;
    }(),
    handleNationEduError: function handleNationEduError() {
      var errorCode = this.$route.query && this.$route.query.nationEduError;
      if (!errorCode) {
        return;
      }
      var messages = {
        "local-user": "当前账号没有可用的教育ID",
        "bind-status": "国家平台绑定状态异常",
        remote: "国家平台认证服务暂时不可用"
      };
      this.showToast(messages[errorCode] || "国家平台认证失败", "error");
      this.$router.replace({
        path: "/",
        query: {}
      });
    },
    toLink: function toLink(item) {
      if (!item.link) return;
      this.$router.push({
        path: item.link
      });
    },
    // 移动端登录
    toLoginMobile: function toLoginMobile() {
      this.$root.$emit("open-portal-login");
    },
    // 移动端搜索
    handleMobileSearch: function handleMobileSearch(keyword) {
      var query = keyword ? {
        courseName: keyword
      } : {};
      this.$router.push({
        path: "/courseSearch",
        query: query
      });
    },
    isShowList: function isShowList() {
      this.$router.push("/allModule");
    },
    initCourse: function initCourse() {
      this.setBannerList();
      this.setCourse();
      this.setPositionList();
      this.setTradeResourceNum();
      this.setPageNumList();
      this.setRandomList();
      this.setResourceNum();
      this.setSpecialCourseTypeCount();
      this.initNews();
    },
    setSpecialCourseTypeCount: function () {
      var _setSpecialCourseTypeCount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var baseCountMap, apiCountMap, res, data, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              baseCountMap = {
                1: 10,
                2: 0,
                3: 0,
                4: 1
              };
              apiCountMap = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
              };
              _context2.prev = 1;
              _context2.next = 2;
              return getSpecialCount({});
            case 2:
              res = _context2.sent;
              data = res && res.data ? res.data : res;
              apiCountMap[1] = Number(data && data.deyu || 0);
              apiCountMap[2] = Number(data && data.tiyu || 0);
              apiCountMap[3] = Number(data && data.meiyu || 0);
              apiCountMap[4] = Number(data && data.laodong || 0);
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
            case 4:
              this.ntwoData = this.ntwoData.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  eduLevel: Number(baseCountMap[item.id] || 0) + Number(apiCountMap[item.id] || 0)
                });
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function setSpecialCourseTypeCount() {
        return _setSpecialCourseTypeCount.apply(this, arguments);
      }
      return setSpecialCourseTypeCount;
    }(),
    initNews: function () {
      var _initNews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, tabs, newsCenter, notice;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return newsTypeList();
            case 1:
              res = _context3.sent;
              tabs = res.rows || [];
              newsCenter = tabs.find(function (item) {
                return item.type === '新闻中心';
              });
              notice = tabs.find(function (item) {
                return item.type === '通知公告';
              });
              this.newsTabList = [{
                type: '新闻中心',
                id: newsCenter ? newsCenter.id : ''
              }, {
                type: '通知公告',
                id: notice ? notice.id : ''
              }];
              this.newsCurIndex = notice ? 1 : 0;
              this.newsQuery.newsTypeId = this.newsTabList[this.newsCurIndex].id;
              this.getHomeNewsList();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initNews() {
        return _initNews.apply(this, arguments);
      }
      return initNews;
    }(),
    changeNewsTab: function changeNewsTab(item, index) {
      this.newsCurIndex = index;
      this.newsQuery.newsTypeId = item.id;
      this.newsQuery.pageNum = 1;
      this.getHomeNewsList();
    },
    getHomeNewsList: function () {
      var _getHomeNewsList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.newsLoading = true;
              _context4.prev = 1;
              _context4.next = 2;
              return newsListMenhu(this.newsQuery);
            case 2:
              res = _context4.sent;
              this.newsList = res.rows || [];
              this.newsTotal = res.total || 0;
            case 3:
              _context4.prev = 3;
              this.newsLoading = false;
              return _context4.finish(3);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1,, 3, 4]]);
      }));
      function getHomeNewsList() {
        return _getHomeNewsList.apply(this, arguments);
      }
      return getHomeNewsList;
    }(),
    handleNewsCurrentChange: function handleNewsCurrentChange(page) {
      this.newsQuery.pageNum = page;
      this.getHomeNewsList();
    },
    handleNewsSizeChange: function handleNewsSizeChange(size) {
      this.newsQuery.pageSize = size;
      this.newsQuery.pageNum = 1;
      this.getHomeNewsList();
    },
    lookNewsDetail: function lookNewsDetail(item) {
      var currentTab = this.newsTabList.find(function (tab) {
        return String(tab.id) === String(item.newsTypeId);
      });
      var type = currentTab ? currentTab.type : '';
      if (item.newsUrl && item.newsUrl.length > 5) {
        window.open(item.newsUrl, "_blank");
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            id: item.id,
            type: type
          }
        });
      }
    },
    initChart5: function initChart5() {
      var _this = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!this.$refs.myechart5) {
        return;
      }
      var num = Math.random() * 90;
      var val = num > 45 ? num + 45 : 45;
      //  const val = num;
      var data = arr.map(function (item) {
        return {
          name: item.name,
          value: val,
          count: val
        };
      });
      var myecharts = echarts.init(this.$refs.myechart5);
      myecharts.setOption(this.setOption(data));
      this.timer = setInterval(function () {
        myecharts.setOption(_this.setOption(data));
      }, 12000);
      window.addEventListener("resize", function () {
        myecharts.resize();
      });
      myecharts.on("click", function (params) {
        var obj = data.filter(function (item) {
          return item.name.includes(params.name);
        });
        _this.$router.push({
          path: "/",
          query: {
            knowledge: obj[0].name
          }
        });
      });
    },
    setOption: function setOption(data) {
      //字符串截取
      var wordLength = function wordLength(value) {
        // let ret = ""; //拼接加\n返回的类目项
        // let maxLength = 4; //每项显示文字个数
        // let valLength = value.length; //X轴类目项的文字个数
        // let rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
        // if (rowN > 1) {
        //   //如果类目项的文字大于3,
        //   for (let i = 0; i < rowN; i++) {
        //     let temp = ""; //每次截取的字符串
        //     let start = i * maxLength; //开始截取的位置
        //     let end = start + maxLength; //结束截取的位置
        //     //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
        //     temp = value.substring(start, end) + "\n";
        //     ret += temp; //凭借最终的字符串
        //   }
        //   return ret;
        // } else {
        //   return value;
        // }
        return value.substring(0, 4);
      };
      var RandomNumBoth = function RandomNumBoth(Min, Max) {
        var Range = Max - Min;
        var Rand = Math.random();
        var num = Min + Math.round(Rand * Range);
        return num;
      };
      //循环定义series的data值
      var datas = [];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var color1 = "rgba(246,223,52,1)";
        var color2 = "rgb(255,132,156)";
        var shadowColor = "rgba(233,49,60,0.23)";
        if (i % 4 == 1) {
          color1 = "rgb(0,186,254)";
          color2 = "rgb(0,133,253)";
          shadowColor = "rgba(45,77,217,0.23)";
        }
        if (i % 4 == 2) {
          color1 = "rgb(154,146,255)";
          color2 = "rgb(104,92,249)";
          shadowColor = "rgba(104,92,250,0.23)";
        }
        if (i % 4 == 3) {
          color1 = "rgb(255,113,125)";
          color2 = "rgb(241,59,59)";
          shadowColor = "rgba(241,61,78,0.23)";
        }
        datas.push({
          name: wordLength(item.name),
          value: [RandomNumBoth(0, 180), RandomNumBoth(0, 150)],
          symbolSize: item.value,
          label: {
            normal: {
              textStyle: {
                fontSize: 8
              }
            }
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.RadialGradient(0.3, 0.5, 0.7, [{
                offset: 0,
                color: color1
              }, {
                offset: 1,
                color: color2
              }]),
              opacity: 1,
              shadowColor: shadowColor,
              shadowBlur: 10,
              shadowOffsetX: 3,
              shadowOffsetY: 3
            }
          }
        });
      }
      var option = {
        grid: {
          show: false,
          top: 10,
          bottom: 10
        },
        xAxis: [{
          gridIndex: 0,
          type: "value",
          show: false,
          min: 0,
          max: 100,
          nameLocation: "middle",
          nameGap: 5
        }],
        yAxis: [{
          gridIndex: 0,
          min: 0,
          show: false,
          max: 100,
          nameLocation: "middle",
          nameGap: 30
        }],
        series: [{
          type: "scatter",
          symbol: "circle",
          // symbolSize: 60,
          label: {
            normal: {
              show: true,
              formatter: "{b}",
              color: "#fff",
              textStyle: {
                fontSize: "8"
              }
            }
            // emphasis: {
            //   show: true,
            //   formatter: "{b}",
            //   color: "#000",
            //   position: "top"
            // }
          },
          itemStyle: {
            normal: {
              color: "#00acea"
            }
          },
          labelLayout: {
            hideOverlap: true // 自动隐藏重叠的标签
            // 或者使用以下更精细的控制：
            // moveOverlap: 'shiftX', // 水平移动重叠标签
            // moveOverlap: 'shiftY', // 垂直移动重叠标签
            // moveOverlap: 'shiftXY' // 同时移动两个方向
          },
          data: datas
        }]
      };
      return option;
    },
    goNext5: function goNext5() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.log("[index.vue] goNext5 fired, item:", JSON.stringify(item));
      if (item.id == 6) {
        return this.$notify.info({
          title: "提示",
          message: "该功能正在建设中"
        });
      }
      var links = '/allModule';
      if (item.id) {
        switch (item.id) {
          case 1:
            links = '/allModule';
            break;
          case 2:
            links = '/allModule';
            break;
          case 3:
            links = '/virtual?courseType=14';
            break;
          case 4:
            links = '/books';
            break;
          // case 6:
          //   links = '/virtual'
          // break;
        }
      }
      this.$router.push(links);
    },
    setBannerList: function () {
      var _setBannerList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return getBannerList();
            case 1:
              res = _context5.sent;
              this.bannerData = res.rows;
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setBannerList() {
        return _setBannerList.apply(this, arguments);
      }
      return setBannerList;
    }(),
    //记录虚拟仿真轮播图对应关系
    lisChange: function lisChange(index) {
      this.$refs.remarkCarusel.setActiveItem(index);
      this.isActive = index;
    },
    //获取课程资源
    setCourse: function setCourse() {
      this.homeNavList.map(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
          var res, data;
          return regeneratorRuntime.wrap(function (_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 1;
                return getCourseNum({
                  type: item.type
                });
              case 1:
                res = _context6.sent;
                data = res.data;
                if (item.type == 1) {
                  item.resourceTypeTotal[0].total = data.majorTotal || 0;
                  item.resourceTypeTotal[1].total = data.onlineTotal || 0;
                  item.resourceTypeTotal[2].total = data.videoTotal || 0;
                } else {
                  item.resourceTypeTotal[0].total = data.total || 0;
                }
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 你从事什么职业呢
    setPositionList: function () {
      var _setPositionList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, _res$rows, rows, _res$total, total;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return getPositionList();
            case 1:
              res = _context7.sent;
              _res$rows = res.rows, rows = _res$rows === void 0 ? [] : _res$rows, _res$total = res.total, total = _res$total === void 0 ? 0 : _res$total;
              this.$store.commit('settings/getwJob', rows);
              this.twoData = rows.slice(0, 8);
              this.resourceTotal = total;
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setPositionList() {
        return _setPositionList.apply(this, arguments);
      }
      return setPositionList;
    }(),
    setTradeResourceNum: function () {
      var _setTradeResourceNum = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, data, len, maxlen, groups, i;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return getTradeResourceNum();
            case 1:
              res = _context8.sent;
              data = res.data;
              len = data.length;
              maxlen = Math.floor(len / 10);
              groups = [];
              for (i = 0; i <= maxlen; i++) {
                groups.push(data.slice(i * 5, i * 5 + 5));
              }
              this.industryData = groups;
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function setTradeResourceNum() {
        return _setTradeResourceNum.apply(this, arguments);
      }
      return setTradeResourceNum;
    }(),
    // 想学习的专业来这里
    setPageNumList: function () {
      var _setPageNumList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res, _res$rows2, rows, len, maxlen, groups, i;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return getPageNumList();
            case 1:
              res = _context9.sent;
              _res$rows2 = res.rows, rows = _res$rows2 === void 0 ? [] : _res$rows2;
              len = rows.length;
              maxlen = Math.floor(len / 10);
              rows.map(function (item, index) {
                var tindex = index % 19;
                item.tindex = tindex;
              });
              groups = [];
              for (i = 0; i <= maxlen; i++) {
                groups.push(rows.slice(i * 10, i * 10 + 10));
              }
              this.majorData = groups;
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setPageNumList() {
        return _setPageNumList.apply(this, arguments);
      }
      return setPageNumList;
    }(),
    // 您关注的知识在这里
    setRandomList: function () {
      var _setRandomList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return getRandomList100();
            case 1:
              res = _context0.sent;
              this.initChart5(res);
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function setRandomList() {
        return _setRandomList.apply(this, arguments);
      }
      return setRandomList;
    }(),
    setResourceNum: function () {
      var _setResourceNum = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var res, data;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.next = 1;
              return getResourceNum();
            case 1:
              res = _context1.sent;
              data = res.data; // resType
              this.$set(this.resType[0], 'count', data.courseNum);
              this.$set(this.resType[1], 'count', data.videoNum);
              this.$set(this.resType[2], 'count', data.virtuallyNum);
              this.$set(this.resType[3], 'count', data.courseMaterialNum);
              this.$set(this.resType[4], 'count', data.onlineNum);
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function setResourceNum() {
        return _setResourceNum.apply(this, arguments);
      }
      return setResourceNum;
    }(),
    //专题跳转
    clickZt: function clickZt(_ref2) {
      var id = _ref2.id;
      if (id == 1) {
        this.deyu();
      }
      if (id == 2) {
        this.tiYu();
      }
      if (id == 3) {
        this.meiyu();
      }
      if (id == 4) {
        this.laoDong();
      }
    },
    // 德育跳转
    deyu: function deyu() {
      this.$router.push({
        path: "/deYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "德育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 体育跳转
    tiYu: function tiYu() {
      this.$router.push({
        path: "/tiYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "体育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 美育跳转
    meiyu: function meiyu() {
      this.$router.push({
        path: "/meiYu"
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "美育",
          // 轮播图名称
          special_name: ""
        }]
      });
    },
    // 劳动教育跳转
    laoDong: function laoDong() {
      window.open("https://ldjy.ykt.eduyun.cn/zjldjy");
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "劳动教育",
          // 轮播图名称
          special_name: ""
        }]
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};